import { Card, CardSection, CardFileState, CardRow, CardRowState, CardGetMode, CardTask } from "tessa/cards";
import { IControlViewModel, ICardModel, ICardUIExtensionContext } from "tessa/ui/cards";
import { DotNetType, createTypedField, Visibility, Guid } from "tessa/platform";
import { GridViewModel, GridRowAction } from "tessa/ui/cards/controls";
import { showNotEmpty, showError, LoadingOverlay} from "tessa/ui";
import { CardRequest, CardService, CardGetRequest } from "tessa/cards/service";
import { CdRequestTypes } from "../CdRequestTypes";
import { ChFileCategories } from "src/pkScripts/Helpers/ChFileCategories";
import { CdExecutiveSchemeTypes } from "../CdExecutiveSchemeTypes";
import { CdFdTaskTypes } from "../CdFdTaskTypes";
import { CdFdProcessHelper } from "../CdFdProcessHelper";
import { ValidationResultType } from "tessa/platform/validation";
import { ApproversRoleID } from "../Dictionaries/ApproversRoleID";
import { CdExecutiveSchemeSharedHelper } from "./CdExecutiveSchemeSharedHelper";
import { ArrayStorage } from "tessa/platform/storage";
import {CdGeneralDocumentationClientHelper} from './CdGeneralDocumentationClientHelper';
import { CdCardTypes } from "../CdCardTypes";
import { CdUIHelper } from "src/cdScripts/UI/CdUIHelper";


export class CdExecutiveSchemeClientHelper extends CdGeneralDocumentationClientHelper{

  public static PdfForPrint: string = ' (для печати).pdf';

  /** Проверка после завершении задания */
  public static async CheckFieldsAfterTaskComplete(context: ICardUIExtensionContext, tasks: ArrayStorage<CardTask>) {
    let deletedTaskIndex = tasks.findIndex(x => x.state === CardRowState.Deleted);
    if (deletedTaskIndex >= 0) {
      let checkAddedFiles: boolean = await this.CheckAddedFiles(context, 1);
      let checkAddNewMatchingRoles: boolean = this.CheckAddNewMatchingRoles(context);
      //let fillFdRoute: boolean = this.FillFdRoute(context);
      if (!checkAddedFiles ||
          !checkAddNewMatchingRoles 
          //!fillFdRoute
          ) {
        context.cancel = true;
        return;
      }
    }

    deletedTaskIndex = tasks.findIndex(x =>
      x.state === CardRowState.Deleted &&
      (x.typeId === CdFdTaskTypes.PkSignExecutiveSchemeInitializingTypeID.toLowerCase() ||
      x.typeId === CdFdTaskTypes.PkExecutiveSchemeToReworkTypeID.toLowerCase()) &&
      (x.optionId === CdFdProcessHelper.PkSendForResigning.toLowerCase() ||
      x.optionId === CdFdProcessHelper.PkSendForSigning.toLowerCase()));
    let deletedArchiveTaskIndex = tasks.findIndex(x =>
      x.state === CardRowState.Deleted &&
      x.typeId === CdFdTaskTypes.PkFdInArchiveTypeID.toLowerCase() &&
      x.optionId === CdFdProcessHelper.ToArchive.toLowerCase());
    if (deletedTaskIndex >= 0) {
      let checkContentFile: boolean = await CdUIHelper.CheckContentFileAsync(context.model.card);
      let checkApprovers: boolean = this.CheckApprovers(context,'PkExecutiveSchemeMatching','PkExecutiveSchemeRoles');
      if (!checkContentFile || !checkApprovers) {
        context.cancel = true;
        return;
      }
    } else if (deletedArchiveTaskIndex >= 0) {
      let edmSection = context.model.card.sections.tryGet('PkExecutiveDocumentationMatching');
      if (edmSection) {
        let cnmRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.Contractor &&
          x.has('LegalEntityID') &&
          x.tryGet('LegalEntityID') !== null &&
          x.tryGet('LegalEntityID') !== undefined &&
          x.tryGet('LegalEntityID') !== '00000000-0000-0000-0000-000000000000');
        if (!cnmRow) {
          let orgnzForFill = '';
          let roleNameRow = edmSection.rows.find(x =>
            x.has('RoleID') &&
            x.tryGet('RoleID') === ApproversRoleID.Contractor);
          if (roleNameRow) {
            orgnzForFill += '\n' + roleNameRow.tryGet('RoleName');
            context.validationResult.add(ValidationResultType.Error, 'Необходимо заполнить юридическое лицо:' + orgnzForFill);
            context.cancel = true;
            return;
          }
        }
      }
    }
    
    await this.SignFilesAsync(context, tasks, CdExecutiveSchemeSharedHelper.ApproverTaskStoreInfo.TaskSignTypesList);
  }

  public static CheckApprovementTableOrder(context: ICardUIExtensionContext) {
    let card = context.card;
    let edmSection = card.sections.tryGet('PkExecutiveSchemeMatching');
    if (edmSection &&
        edmSection.rows.findIndex(x =>
          x.state === CardRowState.Modified ||
          x.state === CardRowState.Inserted) >= 0) {    
     
        let roleIDs: number[] = [];
        let step = 0;       
        for (let i = 0; i < edmSection.rows.length; i++)
          roleIDs.push(edmSection.rows[i].get('RoleID'));
        roleIDs.sort();
        for (let i = 0; i < roleIDs.length; i++) {          
          let roleIDIndex = edmSection.rows.findIndex(x =>
            x.has('RoleID') &&
            x.get('RoleID') === roleIDs[i]);
          edmSection.rows[roleIDIndex].set('Order', createTypedField(step, DotNetType.Int32));
          step++;
        }      
    }
  }

  public static TableOrderLogic(context: ICardUIExtensionContext) {    
     
      let matchingControlViewModel: IControlViewModel | undefined = context.model.controls.get('Matching');
      if (matchingControlViewModel) {
        let controlViewModel = matchingControlViewModel as GridViewModel | null;
        if (controlViewModel) {
          controlViewModel.rowInvoked.add(e => {
            if (e.action === GridRowAction.Deleting)
            { 
              e.cancel = true;
              let eorder = e.row.tryGetField("Order")!.$value;
              controlViewModel!.rows.forEach(row => {
                let order = row.row.tryGetField("Order")!.$value;                
                if (order && row.rowId != e.row.rowId && order>=eorder)
                  row.row.set("Order",createTypedField(order+1, DotNetType.Int32))
              });               
            }
            if (e.action === GridRowAction.Inserted){                  
              e.cancel = true;                          
            }

          });
        }
      }
   
  }

  
  public static FieldsExecutiveSchemeLogic(card: Card, model: ICardModel, context: ICardUIExtensionContext) {
    let esInfoSection = card.sections.tryGet('PkExecutiveSchemeInfo');
  
    let techDocPageControl: IControlViewModel | undefined = model.controls.get('TechDocPageControl');
    let useTechDocPageAsExecutiveSchemeControl: IControlViewModel | undefined = model.controls.get('UseTechDocPageAsExecutiveSchemeControl');
    if (techDocPageControl && useTechDocPageAsExecutiveSchemeControl && esInfoSection) {

      let useTechDocPageAsExecutiveScheme = esInfoSection.fields.get("UseTechDocPageAsExecutiveScheme");
      let executiveSchemeTypeID = esInfoSection.fields.get("ExecutiveSchemeTypeID");
      this.UpdateControlVisability(techDocPageControl,useTechDocPageAsExecutiveScheme&&executiveSchemeTypeID==CdExecutiveSchemeTypes.NonGeodeticSchemeType);
      this.UpdateControlVisability(useTechDocPageAsExecutiveSchemeControl,executiveSchemeTypeID==CdExecutiveSchemeTypes.NonGeodeticSchemeType);
      
      esInfoSection.fields.fieldChanged.add(e => {
        
        if (e.fieldName === 'ExecutiveSchemeTypeID') {    
          
          esInfoSection!.fields.set('UseTechDocPageAsExecutiveScheme',createTypedField(false, DotNetType.Boolean));
          esInfoSection!.fields.set('TechnicalDocumentationPageFileID',null);
          esInfoSection!.fields.set('TechnicalDocumentationPageID',null);
          esInfoSection!.fields.set('TechnicalDocumentationPageOrder',null);
          esInfoSection!.fields.set('TechnicalDocumentationPageName',null);

          executiveSchemeTypeID = e.fieldValue;         
          this.UpdateControlVisability(useTechDocPageAsExecutiveSchemeControl,executiveSchemeTypeID==CdExecutiveSchemeTypes.NonGeodeticSchemeType);
          if (executiveSchemeTypeID != CdExecutiveSchemeTypes.NonGeodeticSchemeType) {
            this.UpdateControlVisability(techDocPageControl,false);
          }  
          this.FillESTableApprovers(card,executiveSchemeTypeID).then(()=>{this.FillApproversByObject(card)})  
          if (executiveSchemeTypeID == CdExecutiveSchemeTypes.GeodeticSchemeType){
            this.FillApproversFromRDND(card);
          }  
        }

        if (e.fieldName === 'UseTechDocPageAsExecutiveScheme') {  
          
          if (esInfoSection){
            esInfoSection.fields.set("TechnicalDocumentationPageFileID",null);
            esInfoSection.fields.set("TechnicalDocumentationPageID",null);
            esInfoSection.fields.set("TechnicalDocumentationPageOrder",null);
            esInfoSection.fields.set("TechnicalDocumentationPageName",null);
          }
         

          useTechDocPageAsExecutiveScheme = e.fieldValue;  
          if (useTechDocPageAsExecutiveScheme == true)
          {            
              if (!(confirm("Подтверждаю, что работы предъявляемые к освидетельствованию выполнены в соответствии с РД.")))
              {                
                esInfoSection!.fields.set('UseTechDocPageAsExecutiveScheme',createTypedField(false, DotNetType.Boolean));
                return;    
              }    
          }
          this.UpdateControlVisability(techDocPageControl,useTechDocPageAsExecutiveScheme);            
        }

        if (e.fieldName === 'TechnicalDocumentationPageID') {  
                  this.SaveCardToUpdateFiles(context)          
        }


      }); 
    }
  }


  public static SaveCardToUpdateFiles(context: ICardUIExtensionContext)
  {    
    LoadingOverlay.instance.show(async () => {
      let editor = context.uiContext.cardEditor;
      editor!.saveCard(context.uiContext);
      });   
  }

public static FillApproversLogic(card: Card, model: ICardModel) {
  const objects = model.controls.get('Objects') as GridViewModel;
  if (!objects) return;  
  let objSection: CardSection | undefined = card.sections.tryGet('PkObjectList');
  let edRolesSection: CardSection | undefined = card.sections.tryGet('PkExecutiveSchemeRoles');
  let edMatchingSection: CardSection | undefined = card.sections.tryGet('PkExecutiveSchemeMatching');
  if (!objSection || !edRolesSection || !edMatchingSection) return;
  objects.rowInitializing.add(e => {
    e.row.fieldChanged.add(async e2 => {
      if (e2.fieldName !== "ObjectID" || !e) return;
      this.FillApproversByObject(card);
      this.FillApproversFromRDND(card);
    });
  });
}

public static async FillESTableApprovers(card: Card, executiveSchemeTypeID: guid)
  {
    let esmSection = card.sections.tryGet('PkExecutiveSchemeMatching');
    if (!esmSection)
    {
        return;
    }
    if (esmSection.rows.length != 0)
    {
      for (let i = esmSection.rows.length - 1; i >= 0; i--) {
        if (esmSection.rows[i].state === CardRowState.Inserted)
          esmSection.rows.splice(i, 1);
        else esmSection.rows[i].state = CardRowState.Deleted;
      }     
    }

    var roles = await this.GetTableRolesES(executiveSchemeTypeID);
    if (roles == null) return;
    let sc: CardSection | undefined = card.sections.tryGet('PkExecutiveSchemeInfo');
    let isRenovation = sc?.fields.tryGet('IsRenovation', null);
    let typeID = sc?.fields.tryGet('ExecutiveSchemeTypeID', null);
    if (roles.length > 0){
      roles.forEach(row => {
        if (isRenovation === true &&
            typeID && typeID === CdExecutiveSchemeTypes.GeodeticSchemeType &&
            row.RoleID === 0) {
              return;
        }
        let esmSectionRow = new CardRow();
        esmSectionRow.rowId = Guid.newGuid();
        esmSectionRow.set("RoleID", row["RoleID"], DotNetType.Int32);
        esmSectionRow.set("RoleName", row["RoleName"], DotNetType.String);
        esmSectionRow.set("LegalEntityID",null, DotNetType.Guid);
        esmSectionRow.set("LegalEntityExternalID", null, DotNetType.Int32);
        esmSectionRow.set("LegalEntityName", null, DotNetType.String);
        esmSectionRow.set("Order", row["RoleID"], DotNetType.Int32);        
        esmSectionRow.state = CardRowState.Inserted;
        esmSection!.rows.push(esmSectionRow);
      });
    }     
  }  

  public static async GetTableRolesES(executiveSchemeTypeID:guid)
  { 
      let result = new Array();
      if (executiveSchemeTypeID == null) return result;
      const request = new CardGetRequest();
      request.getMode = CardGetMode.ReadOnly;
      request.cardId = executiveSchemeTypeID;
      const response = await CardService.instance.get(request);

      await showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
        return;
      }
      const esTypeCard = response.card;           
      let pkEsTypeSignerRolesSection = esTypeCard.sections.tryGet("PkEsTypeSignerRoles");
      if (!pkEsTypeSignerRolesSection) return result;
      
      let rows = pkEsTypeSignerRolesSection.rows;
      rows.forEach(row => {
        var role = {RoleName: row.get("RoleName"), RoleID: row.get("RoleID")};
        result.push(role);
      });
      return result;
  }

  public static async FillApproversByObject(card: Card)
  {
   
    let objSection: CardSection | undefined = card.sections.tryGet('PkObjectList');
    let dciSection: CardSection | undefined = card.sections.tryGet('DocumentCommonInfo');
    let edRolesSection: CardSection | undefined = card.sections.tryGet('PkExecutiveSchemeRoles');
    let edMatchingSection: CardSection | undefined = card.sections.tryGet('PkExecutiveSchemeMatching');
    if (!objSection) return;
    let section: ArrayStorage<CardRow> = objSection.rows;

    if (section.length > 0) {
      let objects: string = '';
      for (let i = 0; i < section.length; i++) {
        let row  = section[i];
        objects += row.tryGet('ObjectID');
        if (i !== section.length) {
          objects += ';';
        }
      }
      let authorId = dciSection!.fields.get("AuthorID")
      const request = new CardRequest();
      request.requestType = CdRequestTypes.GetEsApproversByObjects;
      request.cardId = card.id;
      request.info["Objects"] = createTypedField(objects, DotNetType.String);
      request.info["AuthorID"] = createTypedField(authorId, DotNetType.Guid);

      const response = await CardService.instance.request(request);
      await showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
          return null;
      }

      //очищаем
      if (edRolesSection && edMatchingSection) {
        for (let j = edRolesSection.rows.length - 1; j >= 0; j--) {
          let row = edRolesSection.rows[j];
          if (row.state !== CardRowState.Inserted) {
              row.state = CardRowState.Deleted;
          } 
          else
          {
            edRolesSection.rows.remove(row);
          }
        }
      }
      
      let roles = CdExecutiveSchemeSharedHelper.GetRoles();
      for (let i = 0; i < roles.length; i++) { // Начинается с 0
        if (!response.info!['EdApproversID' + i] ||
            !response.info!['EdApproversID' + i].$value) {
          continue;
        }
        let edApproversID: string[] | null = response.info!['EdApproversID' + i].$value.split(';');
        let edApproversName: string[] | null = response.info!['EdApproversName' + i].$value.split(';');

        if (!edApproversID || !edApproversName) {
          continue;
        }

        if (edApproversID.length === 0 ||
            edApproversID.length !== edApproversName.length) {
              continue;
        }

        if (edRolesSection && edMatchingSection) {         

          for (let j = 0; j < edMatchingSection.rows.length; j++) {
            let row = edMatchingSection.rows[j];
            if (row.state == CardRowState.Deleted) 
              continue;
            let roleID = row.tryGetField('RoleID');
            if (roleID && roleID.$value === i) {              
              for (let k = 0; k < edApproversID.length; k++) {
                if (row.rowId != "" && edApproversID[k] != "" && edApproversName[k] != ""){
                  let newRow = new CardRow();
                  newRow.rowId = Guid.newGuid();
                  newRow.set("MatchingRowID", createTypedField(row.rowId, DotNetType.Guid));
                  newRow.set("RoleID", createTypedField(edApproversID[k], DotNetType.Guid));
                  newRow.set("RoleName", createTypedField(edApproversName[k], DotNetType.String));      
                  newRow.set("RoleKCKID", null);
                  newRow.set("RoleKCKName", null);
                  newRow.set("RoleKCKExternalID", null);
                  newRow.set("RoleEntityID", null);
                  newRow.set("RoleEntityName", null);
                  newRow.set("RolePosition", null);                           
                  newRow.state = CardRowState.Inserted;
                  card.sections.get("PkExecutiveSchemeRoles")!.rows.push(newRow);  
                  this.FillLegalEntityField(newRow, card, row.rowId, 'PkExecutiveSchemeMatching');}
              }
            }
          }
        }
      }
    }

  }


  /** Логика объектов разделов РД */
  public static FieldsObjectsWorksLogic(card: Card, model: ICardModel) {
    let ediSection = card.sections.tryGet('PkExecutiveDocumentationInfo');
    let wftSection = card.sections.tryGet('PkExecutiveDocumentationWorksForTemplate');

    // Обработка флага "РД отсутствует в архиве"
    let workTextControl: IControlViewModel | undefined = model.controls.get('WorkTextControl');
    let workRefControl: IControlViewModel | undefined = model.controls.get('WorkRefControl');
    if (workTextControl && workRefControl && ediSection) {
      let missingTechnicalDocumentation: boolean | undefined = ediSection.fields.tryGet('MissingTechnicalDocumentation');
      this.UpdateWorkControlsVisability(missingTechnicalDocumentation, workTextControl, workRefControl);

      ediSection.fields.fieldChanged.add(e => {
        if (e.fieldName === 'MissingTechnicalDocumentation') {
          missingTechnicalDocumentation = e.fieldValue;
          if (workTextControl && workRefControl)
            this.UpdateWorkControlsVisability(missingTechnicalDocumentation, workTextControl, workRefControl);
        }
      });
    }

    // Заполнение ЖК для при смене объекта
    const objects = model.controls.get('Objects') as GridViewModel;
    if (objects && ediSection && ediSection.fields.has('ResidentialComplexID')) {
      objects.rowInitializing.add(e => {
        e.row.fieldChanged.add(e1 => {
          console.log('1');
          if (card.typeId === CdCardTypes.PkExecutiveSchemeTypeID &&
            e1.fieldName === 'ObjectID') {
              console.log('2');
              this.SetRenovation(card, e1.fieldValue);
          }

          if (e1.fieldName === 'ResidentialComplexID') {
            let residentialComplexID = e1.fieldValue as guid | undefined;
            if (residentialComplexID && ediSection) {
              ediSection.fields.set('ResidentialComplexID', createTypedField(residentialComplexID, DotNetType.Guid));
            }
          } else if (e1.fieldName === 'RegionID') {
            let regionID = e1.fieldValue as guid | undefined;
            if (regionID && ediSection) {
              ediSection.fields.set('RegionID', createTypedField(regionID, DotNetType.Guid));
            }
          }
        });
      });
    }

    // Тех документация
    if (wftSection) {
      wftSection.rows.collectionChanged.add(e => {
        if (e.added.length > 0) {
          let row: CardRow = e.added[0];
          row.fieldChanged.add(async e1 => {
            if (e1.fieldName === 'WorkTechnicalDocumentationID') {
              let tdId = e1.fieldValue;
              if (!tdId) {
                row.set('Number', createTypedField(null, DotNetType.String));
                row.set('RdDivision', createTypedField(null, DotNetType.String));
                row.set('ContractDivision', createTypedField(null, DotNetType.String));
                row.set('Version', createTypedField(null, DotNetType.String));
                return;
              }

              const request = new CardRequest();
              request.requestType = CdRequestTypes.GetRdInfo;
              request.info["CardID"] = createTypedField(tdId, DotNetType.Guid);

              const response = await CardService.instance.request(request);
              await showNotEmpty(response.validationResult.build());
              if (!response.validationResult.isSuccessful) {
                  return null;
              }

              let docNumber = row.tryGetField('WorkTechnicalDocumentationFullNumber');
              let respInfo = response.info;
              if (respInfo && respInfo.ArNumber && respInfo.ArNumber.$value)
                row.set('Number', createTypedField(respInfo.ArNumber.$value, DotNetType.String));
              else if (docNumber)
                row.set('Number', createTypedField(docNumber.$value, DotNetType.String));

              if (respInfo && respInfo.RdDivision && respInfo.ContractDivision && respInfo.Version) {
                row.set('RdDivision', createTypedField(respInfo.RdDivision.$value, DotNetType.String));
                row.set('ContractDivision', createTypedField(respInfo.ContractDivision.$value, DotNetType.String));
                row.set('Version', createTypedField(respInfo.Version.$value, DotNetType.String));
              }
              let sect =  card.sections.getOrAdd('PkExecutiveSchemeFieldsVirtual'); 
              sect!.fields.set('TechDocumentsIdString',wftSection!.rows.map(x=>x.get("WorkTechnicalDocumentationID")).reduce((current, id) => current + ";" + id),DotNetType.String);    
            }
          });
        }                
        let sect =  card.sections.getOrAdd('PkExecutiveSchemeFieldsVirtual'); 
        sect!.fields.set('TechDocumentsIdString',wftSection!.rows.map(x=>x.get("WorkTechnicalDocumentationID")).reduce((current, id) => current + ";" + id),DotNetType.String);   
      });
    }
  }

  /** Проверка файлов в ИС
  * from: 0 - ui, 1 - задание */
  public static async CheckAddedFiles(context: ICardUIExtensionContext, from: number) {
    let card: Card = context.model.card;
    let result: boolean = true;

    switch (from) {
      // Проверяемые расширения файлов
      case 0:
        const availibleFileExtensions: string[] = [ 'DOCX', 'DOC', 'XLSX', 'XLS', 'PDF', 'SGN' ];
        for (let i = 0; i < card.files.length; i++) {
          let file = card.files[i];
          if (file.state === CardFileState.Deleted ||
              file.name.toLowerCase() === 'история согласования.html') continue;
          let correctFile: boolean = false;
          for (let j = 0; j < availibleFileExtensions.length; j++) {
            let ext = availibleFileExtensions[j];
            if (file.name.toUpperCase().indexOf('.' + ext) !== -1) {
              correctFile = true;
              break;
            }
          }
          if (!correctFile) {
            showError('Приложенные файлы должены быть в формате: ' + availibleFileExtensions.join(', '));
            context.cancel = true;
            return true;
          }
        }
        break;
      // Проверка наличия файлов в категориях
      case 1:
        // Проверка, что все файлы сохранены
        if (context.card.tasks.findIndex(x =>
              x.state === CardRowState.Deleted &&
              (x.typeId === CdFdTaskTypes.PkSignExecutiveSchemeInitializingTypeID.toLowerCase() ||
              x.typeId === CdFdTaskTypes.PkExecutiveSchemeToReworkTypeID.toLowerCase())) >= 0 &&
            card.files.findIndex(x =>
              x.state === CardFileState.Inserted ||
              x.state === CardFileState.Modified ||
              x.state === CardFileState.ModifiedAndReplaced ||
              x.state === CardFileState.Replaced) >= 0) {
          context.validationResult.add(ValidationResultType.Error, 'Пожалуйста, сохраните карточку перед тем как продолжить.');
          return false;
        }
        // Проверка файлов в категориях
        let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
        let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
        if (!ediSection || !pdciSection) break;
        let stateID: number | null | undefined = pdciSection.fields.tryGet('StateID');
        if (!stateID) break;
        for (let i = 0; i < context.card.tasks.length; i++) {
          let task = context.card.tasks[i];
          if (task.state !== CardRowState.Deleted ||
              !task.optionId) continue;

          let isInitialization: boolean =            
            task.typeId.toLowerCase() === CdFdTaskTypes.PkSignExecutiveSchemeInitializingTypeID.toLowerCase() &&
            task.optionId.toLowerCase() === CdFdProcessHelper.PkSendForSigning.toLowerCase();
          let isRework: boolean =
            task.typeId.toLowerCase() === CdFdTaskTypes.PkExecutiveSchemeToReworkTypeID.toLowerCase() &&
            task.optionId.toLowerCase() === CdFdProcessHelper.PkSendForResigning.toLowerCase();
         
          let categoryList: string[] = [ ChFileCategories.ImplementingSchemes.id as string ];
          if (isInitialization || isRework) {     
            
            for (let j = 0; j < categoryList.length; j++) {
              let categoryId = categoryList[j];
              let fileIndex = card.files.findIndex(x =>
              x.categoryId !== null &&
              x.categoryId.toLowerCase() === categoryId.toLowerCase());
              if (fileIndex === -1) {
                let category = ChFileCategories.FileCategories.find(x => x.id === categoryId);
                if (category)
                  context.validationResult.add(ValidationResultType.Error, 'Загрузите файл в категорию "' + category.caption + '"');
                  result = false;
                  break;
              }
            }
          }
        }
        break;
    }

    return result;
  }

  /** Логика обычных полей */
  public static FieldLogic(card: Card, model: ICardModel) {
    let ediSection = card.sections.tryGet('PkExecutiveDocumentationInfo');
    let polSection = card.sections.tryGet('PkObjectList');
    //#region Отметить флажки ЗОС и РВЭ
    if (!ediSection) return;
    ediSection.fields.fieldChanged.add(async e => {
      if (e.fieldName === 'EDTypeID') {
        if (ediSection && ediSection.fields.has('isZOS') && ediSection.fields.has('isRVE')) {
          let edTypeID = e.fieldValue as guid | null | undefined;
          if (edTypeID) {
            const edTypeRequest = new CardGetRequest();
            edTypeRequest.getMode = CardGetMode.ReadOnly;
            edTypeRequest.cardId = edTypeID;
            const edTypeResponse = await CardService.instance.get(edTypeRequest);
            const edTypeCard = edTypeResponse.card;
            let edTypeSection = edTypeCard.sections.tryGet('PkExecutiveDocumentationTypes');
            if (edTypeSection && edTypeSection.fields.has('isZOS') && edTypeSection.fields.has('isRVE')) {
              ediSection.fields.set('isZOS', createTypedField(edTypeSection.fields.tryGet('isZOS'), DotNetType.Boolean));
              ediSection.fields.set('isRVE', createTypedField(edTypeSection.fields.tryGet('isRVE'), DotNetType.Boolean));
            }
          } else {
            ediSection.fields.set('isZOS', createTypedField(false, DotNetType.Boolean));
            ediSection.fields.set('isRVE', createTypedField(false, DotNetType.Boolean));
          }
        }
      }
    });
    //#endregion

    //#region Проверка и заполнение ЖК и региона при открытии карточки
    if (ediSection && polSection &&
        ediSection.fields.has('ResidentialComplexID') &&
        ediSection.fields.has('RegionID') &&
        (ediSection.fields.tryGet('ResidentialComplexID') === null ||
        ediSection.fields.tryGet('RegionID') === null)) {
      // ЖК
      if (ediSection.fields.tryGet('ResidentialComplexID') === null) {
        let residentialComplexRow = polSection.rows.find(x =>
          x.has('ResidentialComplexID') &&
          x.tryGet('ResidentialComplexID') !== null);
        if (residentialComplexRow)
          ediSection.fields.rawSet('ResidentialComplexID', createTypedField(residentialComplexRow.get('ResidentialComplexID'), DotNetType.Guid));
      }
      // Регион
      if (ediSection.fields.tryGet('RegionID') === null) {
        let regionRow = polSection.rows.find(x =>
          x.has('RegionID') &&
          x.tryGet('RegionID') !== null);
        if (regionRow)
          ediSection.fields.rawSet('RegionID', createTypedField(regionRow.get('RegionID'), DotNetType.Guid));
      }
    }
    //#endregion

    //#region Отмена удаления записи в таблице согласующих
    let matchingControlViewModel: IControlViewModel | undefined = model.controls.get('Matching');
    if (matchingControlViewModel) {
      let controlViewModel = matchingControlViewModel as GridViewModel | null;
      if (controlViewModel) {
        controlViewModel.rowInvoked.add(e => {
          if (e.action === GridRowAction.Inserted || e.action === GridRowAction.Deleting)
            e.cancel = true;
        });
      }
    }
    //#endregion

    //#region Предзаполнение проекта при добавлении нового объекта
    let objects: IControlViewModel | undefined = model.controls.get('Objects');
    if (objects) {
      let controlViewModel = objects as GridViewModel | null;
      if (controlViewModel) {
        controlViewModel.rowInvoked.add(e => {
          if (polSection && polSection.rows.length > 1 && e.action === GridRowAction.Inserted) {
            let newRow = e.row;
            let oldRow = polSection.rows.find(x =>
              x.rowId !== newRow.rowId);
            if (oldRow &&
                oldRow.has('ProjectID') &&
                oldRow.tryGet('ProjectID') &&
                oldRow.has('ProjectName') &&
                oldRow.tryGet('ProjectName')) {
              let projectID = oldRow.get('ProjectID') as guid;
              let projectName = oldRow.get('ProjectName') as string;
              newRow.set('ProjectID', createTypedField(projectID, DotNetType.Guid));
              newRow.set('ProjectName', createTypedField(projectName, DotNetType.String));
            }
          }
        });
      }
    }
    //#endregion
  }

  /**Скрываем таблицу подписантов, если объект не заполнен */
  public static CheckObjectsAreFilled(card: Card) : boolean{
    if (card.sections.tryGet("PkObjectList")!.rows.length > 0)
      return true;
    else
      return false;
  }

  /** Заполнить "представителя заказчика, ответственного за геодезическую проверку выполненных работ" в ТЧ Подписание из приказа ОРД */
  private static async FillApproversFromRDND(card: Card){
    let pesi = card.sections.tryGet("PkExecutiveSchemeInfo");
    if (!pesi)
      return;
    let kindId = pesi.fields.tryGet("ExecutiveSchemeTypeID");
    if (!kindId)
      return;    
    if (kindId != CdExecutiveSchemeTypes.GeodeticSchemeType)
      return;
    let section = card.sections.tryGet("PkObjectList");
    if (!section)
      return;
    if (section.rows.length == 0)
      return;
    let objects: string = '';
    for (let i = 0; i < section.rows.length; i++) {
      let row  = section.rows[i];
      objects += row.tryGet('ObjectID');
      if (i !== section.rows.length) {
        objects += ';';
      }
    }
    const request = new CardRequest();
    request.requestType = CdRequestTypes.CdGetGeodesicApproversByObjects;
    request.info["Objects"] = createTypedField(objects, DotNetType.String);

    const response = await CardService.instance.request(request);
    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
        return null;
    }
    if (!response.info['EdApproversID'] && !response.info['EdApproversName'] || response.info["EdApproversID"] == null
    || response.info["EdApproversName"] == null
)
      return;
    let pesr = card.sections.tryGet("PkExecutiveSchemeRoles");
    let pesm = card.sections.tryGet("PkExecutiveSchemeMatching");

    if (pesr == null || pesm == null)
      return;
    
    //let matchingRowID = pesm.rows.find(x => x.tryGet("RoleID") == 2)!.tryGet("RowID");
    let matchingRowID : DotNetType.Guid = '00000000-0000-0000-0000-000000000000' as DotNetType.Guid;

    pesm.rows.forEach(row => {
      if (row.state != CardRowState.Deleted){
        if (row.tryGet("RoleID") == 2){
          matchingRowID = row.get("RowID");
        }
      }
    });
    if (matchingRowID == '00000000-0000-0000-0000-000000000000' as DotNetType.Guid)
      return;

    let userIds : Array<DotNetType.Guid> = new Array<DotNetType.Guid>();

    pesr.rows.forEach(row => {
      if (row.tryGet("MatchingRowID") == matchingRowID){
        userIds.push(row.tryGet("RoleID"));
      }
    });

    var listIdsAsString = response.info["EdApproversID"].$value.split(';');
    var listNames = response.info["EdApproversName"].$value.split(';');

    for( let i = 0; i < listIdsAsString.length; i++){
      if (listIdsAsString[i] == null)
        continue;
      let isExists : boolean = false;

      for (let userId of userIds) {
        if (userId == listIdsAsString[i]){
          isExists = true;
          break;        
        }
      }
      if (isExists)
        continue;

      var newRow = new CardRow();

      if (listNames[i] != "" && listIdsAsString[i] != "" && matchingRowID != ""){
        newRow.set("MatchingRowID", createTypedField(matchingRowID, DotNetType.Guid));
        newRow.set("RoleName", createTypedField(listNames[i], DotNetType.String));
        newRow.set("RoleID", createTypedField(listIdsAsString[i], DotNetType.Guid));
        newRow.set("RoleKCKID", null);
        newRow.set("RoleKCKName", null);
        newRow.set("RoleKCKExternalID", null);
        newRow.set("RoleEntityID", null);
        newRow.set("RoleEntityName", null);
        newRow.set("RolePosition", null);           
  
        newRow.state = CardRowState.Inserted;
        pesr.rows.push(newRow);
        this.FillLegalEntityField(newRow, card, matchingRowID,'PkExecutiveSchemeMatching');
      }
    }
  }

  /** Проверить добавление нового согласующего в ТЧ */
  public static CheckAddNewMatchingRoles(context: ICardUIExtensionContext) {
    try {
      let card = context.model.card;
      let edmSection = card.sections.tryGet('PkExecutiveSchemeMatching');
      let edrSection = card.sections.tryGet('PkExecutiveSchemeRoles');
      if (edmSection && edrSection &&
          (edmSection.rows.findIndex(x =>
            x.state === CardRowState.Modified) >= 0 ||
          edrSection.rows.findIndex(x =>
            x.state === CardRowState.Inserted ||
            x.state === CardRowState.Modified) >= 0)) {
          context.validationResult.add(ValidationResultType.Error, 'Сохраните карточку перед тем как продолжить');
          return false;
        }
      return true;
    } catch (ex) {
      context.validationResult.add(ValidationResultType.Error, 'Ошибка при проверке добавления новых согласующих.\nТекст ошибки: ' + ex.message + ' ' + ex.stack);
      return false;
    }
  }

  private static UpdateControlVisability(control: IControlViewModel | undefined, visible: boolean | undefined) {
    if (control !== undefined &&
      control)
      control.controlVisibility = visible?Visibility.Visible:Visibility.Collapsed;      
  }

  /** Обновить видимость контролов работ */
  private static UpdateWorkControlsVisability(missingTechnicalDocumentation: boolean | undefined, workTextControl: IControlViewModel, workRefControl: IControlViewModel) {
    if (missingTechnicalDocumentation !== undefined &&
        missingTechnicalDocumentation)
          this.UpdateControlsVisability(workTextControl, workRefControl);
    else
          this.UpdateControlsVisability(workRefControl, workTextControl);
  }

  /** Включает первый контрол и выключает второй */
  private static UpdateControlsVisability(firstControl: IControlViewModel, secondControl: IControlViewModel) {
    if (firstControl.controlVisibility !== Visibility.Visible)
      firstControl.controlVisibility = Visibility.Visible;
    if (secondControl.controlVisibility !== Visibility.Collapsed)
      secondControl.controlVisibility = Visibility.Collapsed;
  }  

  private static async SetRenovation(card: Card, objectID: guid | null) {
    var esSection = card.sections.tryGet("PkExecutiveSchemeInfo");
    if (esSection == null)
      return;

    if (objectID)
    {
        var request = new CardRequest();
        request.requestType = CdRequestTypes.GetRenovationAndProjectType;
        request.info["ObjectID"] = createTypedField(objectID, DotNetType.Guid);

        const response = await CardService.instance.request(request);

        if (!response.validationResult.isSuccessful)
          return;
        esSection.fields.set("IsRenovation", response.info.IsRenovation)
    }
  }
}